import React, { useState } from 'react';
import { Container, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';

const Notification = () => {
  // Sample data generator
  const generateSampleData = (count = 40) => {
    const statuses = ['Active', 'Inactive', 'Scheduled', 'Sent', 'Draft'];
    const cities = ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad'];
    const states = ['Maharashtra', 'Delhi', 'Karnataka', 'Telangana', 'Tamil Nadu', 'West Bengal', 'Gujarat'];
    const titles = [
      'System Maintenance Alert',
      'New Feature Launch',
      'Service Update',
      'Payment Reminder',
      'Security Alert',
      'Promotional Offer',
      'Account Update',
      'Transaction Notice'
    ];
    const messages = [
      'System will be under maintenance from 2 AM to 4 AM',
      'Check out our new features for better experience',
      'Important service updates available',
      'Your payment is due soon',
      'Security update required for your account',
      'Special offer: Get 20% discount today',
      'Please update your account information',
      'Transaction completed successfully'
    ];
    
    return Array.from({ length: count }, (_, i) => {
      const createdDate = new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1);
      const scheduleDate = new Date(createdDate.getTime() + Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000);
      
      // Randomly select which column to populate (0: pincode, 1: city, 2: state, 3: userName)
      const activeColumn = Math.floor(Math.random() * 4);
      
      return {
        id: `ANN${String(i + 1).padStart(4, '0')}`,
        title: titles[Math.floor(Math.random() * titles.length)],
        message: messages[Math.floor(Math.random() * messages.length)],
        schedule: scheduleDate.toISOString().split('T')[0],
        createdDate: createdDate.toISOString().split('T')[0],
        createdTime: `${String(Math.floor(Math.random() * 24)).padStart(2, '0')}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}`,
        status: statuses[Math.floor(Math.random() * statuses.length)],
        pincode: activeColumn === 0 ? `${Math.floor(Math.random() * 900000) + 100000}` : '',
        city: activeColumn === 1 ? cities[Math.floor(Math.random() * cities.length)] : '',
        state: activeColumn === 2 ? states[Math.floor(Math.random() * states.length)] : '',
        userName: activeColumn === 3 ? `User${Math.floor(Math.random() * 1000)}` : '',
        app: Math.random() > 0.5,
        sms: Math.random() > 0.5,
        whatsapp: Math.random() > 0.5,
        email: Math.random() > 0.5
      };
    });
  };

  const [data] = useState(generateSampleData(40));
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    schedule: '',
    status: 'Active',
    pincode: '',
    city: '',
    state: '',
    userName: '',
    app: false,
    sms: false,
    whatsapp: false,
    email: false
  });

  // Column definitions
  const columns = [
    {
      key: 'delete',
      label: 'Delete',
      render: (row) => (
        <div className="d-flex gap-1 justify-content-center">
          <Button 
            size="sm" 
            variant="outline-danger"
            title="Delete"
            style={{
              padding: '0.25rem 0.5rem'
            }}
          >
            <i className="bi bi-trash"></i>
          </Button>
        </div>
      )
    },
    { key: 'title', label: 'Title' },
    { 
      key: 'message', 
      label: 'Message',
      render: (row) => (
        <details>
          <summary style={{ 
            cursor: 'pointer', 
            userSelect: 'none',
            color: '#5367fe',
            fontWeight: '500'
          }}>
            View
          </summary>
          <div style={{ marginTop: '8px', padding: '8px', background: '#f8f9fa', borderRadius: '4px' }}>
            {row.message}
          </div>
        </details>
      )
    },
    { key: 'schedule', label: 'Schedule' },
    { key: 'createdDate', label: 'Created Date' },
    { key: 'createdTime', label: 'Created Time' },
    { key: 'status', label: 'Status' },
    { key: 'pincode', label: 'Pincode' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'userName', label: 'User Name' },
    { 
      key: 'app', 
      label: 'App',
      render: (row) => (
        <i className={`bi ${row.app ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}`}></i>
      )
    },
    { 
      key: 'sms', 
      label: 'SMS',
      render: (row) => (
        <i className={`bi ${row.sms ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}`}></i>
      )
    },
    { 
      key: 'whatsapp', 
      label: 'WhatsApp',
      render: (row) => (
        <i className={`bi ${row.whatsapp ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}`}></i>
      )
    },
    { 
      key: 'email', 
      label: 'Email',
      render: (row) => (
        <i className={`bi ${row.email ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}`}></i>
      )
    }
  ];

  const handleAddAnnouncement = () => {
    setShowAddModal(true);
  };

  const handleCloseModal = () => {
    setShowAddModal(false);
    setFormData({
      title: '',
      message: '',
      schedule: '',
      status: 'Active',
      pincode: '',
      city: '',
      state: '',
      userName: '',
      app: false,
      sms: false,
      whatsapp: false,
      email: false
    });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Add logic to save announcement
    handleCloseModal();
  };

  return (
    <Container fluid className="">
      <SettingsTable
        data={data}
        settingsType="Announcement"
        columns={columns}
        onAdd={handleAddAnnouncement}
      />

      {/* Add Announcement Modal */}
      <Modal show={showAddModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e293b' }}>
            <i className="bi bi-megaphone me-2"></i>
            Add New Announcement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '1.5rem', maxHeight: '70vh', overflowY: 'auto' }}>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Enter announcement title"
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Message <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Enter announcement message"
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Schedule Date <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="schedule"
                    value={formData.schedule}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status <span className="text-danger">*</span></Form.Label>
                  <Form.Select
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Scheduled">Scheduled</option>
                    <option value="Sent">Sent</option>
                    <option value="Draft">Draft</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={12}>
                <hr />
                <h6 className="mb-3" style={{ color: '#667eea', fontWeight: '600' }}>
                  <i className="bi bi-geo-alt me-2"></i>
                  Target Audience (Fill only one field)
                </h6>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    placeholder="Enter pincode"
                    maxLength={6}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="Enter city name"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    placeholder="Enter state name"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>User Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="userName"
                    value={formData.userName}
                    onChange={handleInputChange}
                    placeholder="Enter username"
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <hr />
                <h6 className="mb-3" style={{ color: '#667eea', fontWeight: '600' }}>
                  <i className="bi bi-send me-2"></i>
                  Notification Channels
                </h6>
              </Col>

              <Col md={12}>
                <div className="d-flex gap-4 flex-wrap">
                  <Form.Check
                    type="checkbox"
                    id="app-check"
                    name="app"
                    label={<span><i className="bi bi-phone me-1"></i> App Notification</span>}
                    checked={formData.app}
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    type="checkbox"
                    id="sms-check"
                    name="sms"
                    label={<span><i className="bi bi-chat-dots me-1"></i> SMS</span>}
                    checked={formData.sms}
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    type="checkbox"
                    id="whatsapp-check"
                    name="whatsapp"
                    label={<span><i className="bi bi-whatsapp me-1"></i> WhatsApp</span>}
                    checked={formData.whatsapp}
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    type="checkbox"
                    id="email-check"
                    name="email"
                    label={<span><i className="bi bi-envelope me-1"></i> Email</span>}
                    checked={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            onClick={handleCloseModal}
            style={{ 
              padding: '0.5rem 1.5rem',
              backgroundColor: 'transparent',
              border: '2px solid #6c757d',
              color: '#6c757d',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit}
            style={{ 
              padding: '0.5rem 1.5rem',
              backgroundColor: 'transparent',
              border: '2px solid #5367fe',
              color: '#5367fe',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#5367fe';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#5367fe';
            }}
          >
            Save Announcement
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Notification;

